import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../TopExplore/../header/style.css";
import { Header } from "../TopExplore";
import { AdminNavbar } from "../TopExplore";
import {
  API_BASE_URL,
  ACCESS_TOKEN_NAME,
  Image_Base_Url,
} from "../../../constants/apiConstants";
import axios from "axios";

function EditTopExplore() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [instituteName, setInstituteName] = useState("");
  const [existingLobo, setExistingLobo] = useState("");
  const [lobo, setLobo] = useState(null);
  const [status, setStatus] = useState("active");

  useEffect(() => {
    fetchLoboData();
  }, [id]);

  const fetchLoboData = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/getExploreTopStudyPlacesById/${id}`,
        {
          headers: {
            Authorization: `Bearer ${ACCESS_TOKEN_NAME()}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.length > 0) {
        const data = response.data[0];
        setInstituteName(data.title || "");
        setExistingLobo(data.media_image_path || "");
        setStatus(data.status === "1" ? "active" : "inactive");
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  const handleFileChange = (e) => {
    setLobo(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const formData = new FormData();
    // formData.append("role_id", "2"); // Add role_id
    // formData.append("user_id", "3"); // Add user_id
    formData.append("title", instituteName); // Match 'title'
    formData.append("status", status === "active" ? "1" : "0"); // Match 'status'
  
    // Attach image
    if (lobo) {
      formData.append("media_image_name", lobo); // Let the browser use the file name
    } else if (existingLobo) {
      // NOTE: If `existingLobo` is just a file path string, do not append it.
      // This is usually not required unless your backend accepts an image path as fallback.
      // But if required:
      formData.append("media_image_name", existingLobo);
    }
  
    try {
      const response = await axios.post(
        `${API_BASE_URL}/createExploreTopStudyPlaces/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${ACCESS_TOKEN_NAME()}`,
            // Do not manually set 'Content-Type' for FormData
          },
        }
      );
  
      console.log("Response:", response);
  
      if (response.status === 200) {
        navigate("/admin/TopExploreList");
      } else {
        console.error("Unexpected response:", response.status);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };
  

  return (
    <div>
      <Header />
      <div className="main-container">
        <AdminNavbar />
        <div className="main">
          <div className="report-container">
            <div className="report-header">
              <h1 className="recent-Articles">Edit Explore Top Study Places</h1>
            </div>
            <div className="report-body">
              <div className="user-form">
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                  <div className="mb-3">
                    <label htmlFor="institute_name" className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="institute_name"
                      name="institute_name"
                      value={instituteName}
                      onChange={(e) => setInstituteName(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="exam_lobo" className="form-label">Lobo (Upload Image)</label>
                    <input
                      type="file"
                      className="form-control"
                      id="exam_lobo"
                      name="exam_lobo"
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                    {existingLobo && (
                      <div>
                        <p>Current Lobo:</p>
                        <img
                          src={`${Image_Base_Url}${existingLobo}`}
                          alt="Institute Lobo"
                          style={{ width: "100px", height: "100px" }}
                        />
                      </div>
                    )}
                  </div>

                  <div className="mb-3">
                    <label htmlFor="status" className="form-label">Status</label>
                    <select
                      id="status"
                      className="form-control"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>

                  <button type="submit" className="btn btn-primary submit-btn">UPDATE</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditTopExplore;
